<p-table #dt [value]="report"
         class="table table-condensed table-hover table-fixed-header"
         sortField="messageCreatedMs" sortOrder="-1">
  <ng-template pTemplate="header">
      <tr class="table-header-row">
        <th style="width: 200px">{{'_Patient_' | translate | titlecase }}</th>
        <th style="width: 160px">Last Appointment</th>
        <th style="width: 160px">Last Attempt</th>
        <th style="width: 160px" *ngIf="tableType === 'successful'">Next Appointment</th>
        <th style="width: 184px" *ngIf="tableType !== 'successful'">Reason (Last Appointment)</th>
        <th style="width: 184px" *ngIf="tableType === 'successful'">Reason (Next Appointment)</th>
        <th style="text-align: center;">Attempts</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-message let-columns="columns">
    <tr [pSelectableRow]="message" class="table-row">
      <td>
        <ng-container *ngIf="userRoute$ | async as userRoute">
          <a href="{{baseUrl}}/{{userRoute.path}}/?{{userRoute.param}}={{message.personId}}" (click)="setRoute(userRoute.path, userRoute.param, message.personId)">{{message.name}}</a>
        </ng-container>
      </td>
      <td>
        <a href="/appointments/?appointmentid={{message.latestAppointmentId}}"
           (click)="setRoute('/appointments', 'appointmentid', message.latestAppointmentId)">{{message.appointmentTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</a>
      </td>
      <td>{{message.messageCreatedMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</td>

      <td *ngIf="tableType === 'successful'">
        <a href="/appointments/?appointmentid={{message.nextAppointmentId}}"
           (click)="setRoute('/appointments', 'appointmentid', message.nextAppointmentId)">{{message.nextAppointmentTimeMs | amDateFormat: 'MM/DD/YYYY h:mm a'}}</a>
      </td>

      <td *ngIf="tableType !== 'successful'">{{message.reasonName}}</td>
      <td *ngIf="tableType === 'successful'">{{message.nextReasonName}}</td>
      <td style="text-align: center;">{{message.attempt}}</td>
    </tr>
  </ng-template>
</p-table>
